import { Box, Input, Text } from '@nimbus-ds/components';

function FieldsSkeleton() {
  return (
    <Box display="flex" flexDirection="column" gap="4">
      <Box gap="2" display="flex" flexDirection="column">
        <Text.Skeleton />
        <Input.Skeleton />
      </Box>
      <Box gap="2" display="flex" flexDirection="column">
        <Text.Skeleton />
        <Input.Skeleton />
      </Box>
      <Box display="flex" flexDirection="row" gap="4">
        <Box display="flex" flexDirection="column" flexGrow="1">
          <Box gap="2" display="flex" flexDirection="column">
            <Text.Skeleton />
            <Input.Skeleton />
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" flexGrow="1">
          <Box gap="2" display="flex" flexDirection="column">
            <Text.Skeleton />
            <Input.Skeleton />
          </Box>
        </Box>
      </Box>
      <Box display="flex" flexDirection="row" gap="4">
        <Box display="flex" flexDirection="column" flex="1 1 35%">
          <Box gap="2" display="flex" flexDirection="column">
            <Text.Skeleton />
            <Input.Skeleton />
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" flex="1 1 65%">
          <Box gap="2" display="flex" flexDirection="column">
            <Text.Skeleton />
            <Input.Skeleton />
          </Box>
        </Box>
      </Box>
      <Box gap="2" display="flex" flexDirection="column">
        <Text.Skeleton />
        <Input.Skeleton />
      </Box>
    </Box>
  );
}

export default FieldsSkeleton;
